import { Routes } from '@angular/router';
import { authGuard } from './core/guards/auth.guard';
import { isAuthedGuard } from './core/guards/is-authed.guard';
import { isVerifiedAccountStateGuard } from './core/guards/is-verified-account-state.guard';

export const routes: Routes = [
  { path: '', redirectTo: '/login', pathMatch: 'full' },

  // ── Admin feature (lazy chunk) ─────────────────────────────
  // Le contrôle de permission par route est géré en canActivateChild
  // sur le layout admin (cf. admin.routes.ts).
  {
    path: 'admin',
    canActivate: [authGuard],
    loadChildren: () =>
      import('./views/admin/admin.routes').then(m => m.adminRoutes),
  },

  // ── Auth routes (login, password reset…) ──────────────────
  {
    path: '',
    canActivate: [isAuthedGuard],
    loadComponent: () =>
      import('./views/auth/layout/layout.component').then(m => m.LayoutComponent),
    children: [
      {
        path: 'activate-account',
        canActivate: [isVerifiedAccountStateGuard],
        loadComponent: () =>
          import('./views/auth/account-activation/account-activation.component').then(
            m => m.AccountActivationComponent
          ),
      },
      {
        path: 'login',
        loadComponent: () =>
          import('./views/auth/login/login.component').then(m => m.LoginComponent),
      },
      {
        path: 'forget-password',
        loadComponent: () =>
          import('./views/auth/forget-password/forget-password.component').then(
            m => m.ForgetPasswordComponent
          ),
      },
      {
        path: 'recovery-password/:token',
        loadComponent: () =>
          import('./views/auth/recovery-password/recovery-password.component').then(
            m => m.RecoveryPasswordComponent
          ),
      },
    ],
  },

  // ── Protected user pages ───────────────────────────────────
  {
    path: 'user-account',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./views/auth/user-profil/user-profil.component').then(m => m.UserProfilComponent),
  },
  {
    path: 'user-settings',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./views/auth/user-setting/user-setting.component').then(m => m.UserSettingComponent),
  },

  // ── Public pages ───────────────────────────────────────────
  {
    path: '',
    loadChildren: () =>
      import('./views/public/public.routes').then(m => m.publicRoutes),
  },

  // ── Partage public (sans auth) ─────────────────────────────
  {
    path: 'share/:token',
    loadComponent: () =>
      import('./views/admin/pages/share-public/share-public.component').then(
        m => m.SharePublicComponent
      ),
  },

  // ── Fallback ───────────────────────────────────────────────
  {
    path: '404',
    loadComponent: () =>
      import('./views/not-found-component/not-found-component.component').then(
        m => m.NotFoundComponent
      ),
  },
  { path: '**', redirectTo: '/404' },
];
